import { render, staticRenderFns } from "./index.vue?vue&type=template&id=820f8e22&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('820f8e22')) {
      api.createRecord('820f8e22', component.options)
    } else {
      api.reload('820f8e22', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=820f8e22&", function () {
      api.rerender('820f8e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/GenerateForm/index.vue"
export default component.exports